import { render, staticRenderFns } from "./qrPop.vue?vue&type=template&id=03ffda5a&scoped=true&"
import script from "./qrPop.vue?vue&type=script&lang=js&"
export * from "./qrPop.vue?vue&type=script&lang=js&"
import style0 from "./qrPop.vue?vue&type=style&index=0&id=03ffda5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ffda5a",
  null
  
)

export default component.exports